import React from "react";
import ReactDOM from "react-dom";
import Footer from "./Footer";

import "./index.css";

import "bootstrap/dist/css/bootstrap.css";
import App from "./App";

ReactDOM.render(
  <div>
    <App />
    <Footer />
  </div>,
  document.getElementById("root")
);
